;(function () {
  /**
   * Buy More CA Section JavaScript
   */

  const jqDoc = $(document)
  const body = $('body')
  const addLoadingClass = 'is--loading'
  const htmlData = {}

  const unavailable =
    window.T4SProductStrings.unavailable
  const soldOut =
    window.T4SProductStrings.soldOut
  const addText =
    window.T4SProductStrings.addToCart

  function initializeQuickShop() {
    const initializedClass =
      'initProducts__enabled'

    const product = $(
      '.t4s-product-quick-shop:not(.' +
        initializedClass +
        ')'
    )

    if (!product.length) return

    product.addClass(initializedClass)

    new T4SThemeSP.Product(product[0])

    T4SThemeSP.PopupMFP()

    if (
      window.Shopify &&
      Shopify.PaymentButton
    ) {
      Shopify.PaymentButton.init()
    }

    T4SThemeSP.Wishlist.updateAll()
    T4SThemeSP.Compare.updateAll()
    T4SThemeSP.ProductItem.reloadReview()
    T4SThemeSP.Tooltip()

    body.trigger('currency:update')
  }

  function getSafeQuickShopHTML(html) {
    const doc =
      new DOMParser().parseFromString(
        html,
        'text/html'
      )

    const quickShop = doc.querySelector(
      '.t4s-product-quick-shop'
    )

    if (!quickShop) {
      throw new Error(
        'Buy More CA: quick-shop markup was not found'
      )
    }

    const componentStyles = Array.from(
      doc.querySelectorAll(
        'link[rel="stylesheet"]'
      )
    )
      .filter(link => {
        const href =
          link.getAttribute('href') || ''

        return /(?:main-product|qs-product|swatch|base_drop|ani-atc)/i.test(
          href
        )
      })
      .map(link => link.outerHTML)
      .join('')

    return (
      componentStyles +
      quickShop.outerHTML
    )
  }

  function registerModalButton(type) {
    $('.t4s-modal--is-active .lt-add')
      .off('click.buyMoreCA')
      .on(
        'click.buyMoreCA',
        function (event) {
          event.preventDefault()

          const container = $(this).closest(
            '.t4s-product-form__variants'
          )

          const form = container
            .find('form')
            .get(0)

          if (!form) {
            console.error(
              'Buy More CA: product form was not found'
            )
            return
          }

          const data = new FormData(form)

          const variantsElement =
            container.find(
              '.pr_variants_json'
            )

          if (!variantsElement.length) {
            console.error(
              'Buy More CA: variant data was not found'
            )
            return
          }

          const allData = JSON.parse(
            variantsElement.html()
          )

          const item = allData.find(
            variant =>
              variant.id == data.get('id')
          )

          if (!item) {
            console.error(
              'Buy More CA: selected variant was not found'
            )
            return
          }

          const info = {
            id: item.id,
            quantity:
              data.get('quantity') || 1,
            pid: data.get('product-id'),
            price: item.price,
            img:
              item.featured_image?.src ||
              container.data('img'),
            type,
          }

          jqDoc.trigger(
            'lute:match:add',
            info
          )

          body.trigger(
            'modalt4s:closed'
          )
        }
      )

    $('[data-product-featured]')
      .off('variant:changed.buyMoreCA')
      .on(
        'variant:changed.buyMoreCA',
        function (event) {
          const variant =
            event.currentVariant

          const button =
            $(this).find('.lt-add')

          const quantity =
            $(this).find(
              '[data-quantity-wrapper]'
            )

          const buttonText =
            button.find(
              '.t4s-btn-atc_text'
            )

          if (!button.length) return

          if (
            T4SThemeSP
              .isEditCartReplace &&
            !button.is(
              '[data-replace-item]'
            )
          ) {
            button.attr(
              'data-replace-item',
              ''
            )
          }

          if (
            variant &&
            variant !== 'nathan'
          ) {
            if (variant.available) {
              quantity.show()

              button.removeAttr(
                'disabled aria-disabled'
              )

              buttonText.text(addText)
            } else {
              quantity.hide()

              button
                .attr(
                  'disabled',
                  'disabled'
                )
                .attr(
                  'aria-disabled',
                  true
                )

              buttonText.text(soldOut)
            }
          } else {
            button
              .attr(
                'disabled',
                'disabled'
              )
              .attr(
                'aria-disabled',
                true
              )

            buttonText.text(unavailable)
            quantity.hide()
          }
        }
      )
  }

  function generateRandomId() {
    return (
      'id-' +
      Math.random()
        .toString(36)
        .substr(2, 9)
    )
  }

  class BuyMoreCA {
    constructor(section) {
      this.section = section

      this.container =
        section.querySelector(
          '.bmsm-container'
        )

      if (!this.container) return

      this.flag =
        this.container.dataset.flag ||
        'default'

      this.selectedText =
        section.querySelector(
          '.match-bar .selected'
        )

      this.selectedTemp =
        section.querySelector(
          '#bmsm-select-text'
        )?.content

      this.steps =
        section.querySelectorAll(
          '.match-bar .step .item'
        )

      this.discountText =
        section.querySelector(
          '.match-bar .discount-text'
        )

      this.addToCartButton =
        section.querySelector(
          '.cart-btn'
        )

      this.swiperImgs =
        section.querySelector(
          '.match-bar .imgs .swiper'
        )

      this.emptyEl =
        section.querySelector(
          '.match-bar .imgs .empty'
        )

      this.productContainer =
        section.querySelector(
          '.bmsm-products'
        )

      if (
        !this.addToCartButton ||
        !this.swiperImgs ||
        !this.emptyEl ||
        !this.selectedTemp
      ) {
        console.error(
          'Buy More CA: required section elements are missing'
        )
        return
      }

      this.cartItemsContainer =
        this.swiperImgs.querySelector(
          '.swiper-wrapper'
        )

      this.selectedItems = []
      this.matchSwiper = null

      this.discount1 =
        parseFloat(
          this.container.dataset[
            'discount-1'
          ]
        ) || 0

      this.discount2 =
        parseFloat(
          this.container.dataset[
            'discount-2'
          ]
        ) || 0

      this.productsPerPage = Number(
        this.container.dataset.productsPerPage
      ) || 8

      this.productBatchItems = Array.from(
        section.querySelectorAll(
          '[data-bmsm-product-item]'
        )
      )

      this.visibleProductCount =
        this.productBatchItems.filter(
          item => item.style.display !== 'none'
        ).length

      this.loadMorePagination =
        section.querySelector(
          '.t4s-prs-pagination'
        )

      if (this.loadMorePagination) {
          this.loadMoreBtn =
          this.loadMorePagination
            .querySelector(
              '.bmsm-loadmore-btn'
            )

        if (this.loadMoreBtn) {
          this.total = Number(
            this.loadMoreBtn.dataset.total
          )

          this.loadMoreBar =
            this.loadMorePagination
              .querySelector(
                '.t4s-lm-bar--current'
              )

          this.currentPageEl =
            this.loadMorePagination
              .querySelector(
                '[data-current-bar]'
              )
        }
      }

      this.init()
    }

    init() {
      this.addEventListeners()
      this.initSection()

      jqDoc.on(
        `lute:match:add.buyMoreCA-${this.flag}`,
        (event, item) => {
          if (
            item.type !== this.flag
          ) {
            return
          }

          const appendItems = []

          const count = Math.max(
            1,
            Number(item.quantity) || 1
          )

          for (
            let index = 0;
            index < count;
            index++
          ) {
            appendItems.push({
              ...item,
              quantity: 1,
              eid: generateRandomId(),
            })
          }

          this.selectedItems.push(
            ...appendItems
          )

          this.updateSection(
            appendItems
          )
        }
      )
    }

    updateLocalStorage() {
      localStorage.setItem(
        `LUTE:BMSM:${this.flag}`,
        JSON.stringify(
          this.selectedItems
        )
      )
    }

    initSection() {
      const data =
        localStorage.getItem(
          `LUTE:BMSM:${this.flag}`
        )

      try {
        this.selectedItems = data
          ? JSON.parse(data)
          : []
      } catch (error) {
        console.warn(
          'Buy More CA: invalid saved selection was cleared',
          error
        )

        this.selectedItems = []

        localStorage.removeItem(
          `LUTE:BMSM:${this.flag}`
        )
      }

      if (
        this.selectedItems.length > 0
      ) {
        this.initSwiper()

        this.handleAddSlide(
          this.selectedItems
        )

        this.handleTextChange()
        this.handleDotChange()
      }
    }

    updateSection(
      items,
      type = 'add'
    ) {
      this.initSwiper()

      if (
        items &&
        items.length > 0
      ) {
        if (type === 'remove') {
          this.handleRemoveSlide(
            items
          )
        } else {
          this.handleAddSlide(items)
        }
      }

      this.handleTextChange()
      this.handleDotChange()
      this.updateLocalStorage()
    }

    initSwiper() {
      const count =
        this.selectedItems.length

      if (count === 0) {
        this.emptyEl.classList.remove(
          'hidden'
        )

        this.swiperImgs.classList.add(
          'hidden'
        )
      } else {
        this.emptyEl.classList.add(
          'hidden'
        )

        this.swiperImgs.classList.remove(
          'hidden'
        )
      }

      if (
        count > 0 &&
        !this.matchSwiper
      ) {
        this.matchSwiper = new Swiper(
          this.swiperImgs,
          {
            slidesPerView: 'auto',
            centerInsufficientSlides:
              true,
            centeredSlidesBounds: true,
            navigation: {
              nextEl:
                this.section
                  .querySelector(
                    '.match-next-btn'
                  ),
              prevEl:
                this.section
                  .querySelector(
                    '.match-prev-btn'
                  ),
            },
          }
        )
      }
    }

    handleAddSlide(items) {
      if (!this.matchSwiper) return

      const slides = items.map(
        item => {
          return `
            <div
              class="swiper-slide img"
              data-id="${item.eid}"
            >
              <img
                src="${item.img}"
                alt=""
              >
              <div class="close-icon">
                <svg viewBox="0 0 36 36">
                  <use
                    xlink:href="#match-close"
                  ></use>
                </svg>
              </div>
            </div>
          `
        }
      )

      this.matchSwiper.appendSlide(
        slides
      )

      this.matchSwiper.slideTo(
        this.matchSwiper.slides.length -
          1
      )
    }

    handleRemoveSlide(indexes) {
      if (this.matchSwiper) {
        this.matchSwiper.removeSlide(
          indexes
        )
      }
    }

    addCartEvent(buttons) {
      if (!buttons) return

      buttons.forEach(button => {
        if (
          button.dataset
            .buyMoreWatched === 'true'
        ) {
          return
        }

        button.dataset
          .buyMoreWatched = 'true'

        button.addEventListener(
          'click',
          event =>
            this.handleAddProduct(
              event
            )
        )
      })
    }

    addEventListeners() {
      const addButtons =
        this.section
          .querySelectorAll(
            '.bmsm-add-btn'
          )

      this.addCartEvent(addButtons)

      if (
        this.cartItemsContainer
      ) {
        this.cartItemsContainer
          .addEventListener(
            'click',
            event => {
              const closeButton =
                event.target.closest(
                  '.close-icon'
                )

              if (
                closeButton &&
                this.cartItemsContainer
                  .contains(
                    closeButton
                  )
              ) {
                this.handleRemoveItem(
                  closeButton
                )
              }
            }
          )
      }

      this.addToCartButton
        .addEventListener(
          'click',
          event => {
            event.preventDefault()
            this.handleAddToCart()
          }
        )

      if (this.loadMoreBtn) {
        this.loadMoreBtn
          .addEventListener(
            'click',
            event =>
              this.handleLoadMore(
                event
              )
          )
      }
    }

    updateEvents() {
      if (
        typeof T4SThemeSP !==
          'undefined' &&
        T4SThemeSP
          .reinitProductGridItem
      ) {
        T4SThemeSP
          .reinitProductGridItem()
      }

      const addButtons =
        this.section
          .querySelectorAll(
            '.bmsm-add-btn'
          )

      this.addCartEvent(
        addButtons
      )
    }

    handleAddProduct(event) {
      event.preventDefault()
      event.stopPropagation()

      const button =
        event.currentTarget

      if (
        button.classList.contains(
          addLoadingClass
        )
      ) {
        return
      }

      button.classList.add(
        addLoadingClass
      )

      const productCard =
        button.closest('.t4s-product')

      if (!productCard) {
        console.error(
          'Buy More CA: product card was not found'
        )

        button.classList.remove(
          addLoadingClass
        )

        return
      }

      try {
        const productData =
          JSON.parse(
            productCard.getAttribute(
              'data-product-options'
            )
          )

        const productLink =
          productCard.querySelector(
            '[data-pr-href]'
          )

        if (!productLink) {
          throw new Error(
            'Product link was not found'
          )
        }

        const link =
          productLink.getAttribute(
            'href'
          )

        const cachedId =
          'lt-main-qa' +
          productData.id

        if (htmlData[cachedId]) {
          T4SThemeSP.NTpopupInline(
            htmlData[cachedId],
            'lt-main-qa',
            initializeQuickShop,
            't4s-opening-qs'
          )

          body.trigger(
            'modalt4s:opened'
          )

          registerModalButton(
            this.flag
          )

          button.classList.remove(
            addLoadingClass
          )

          return
        }

        const separator =
          link.includes('?')
            ? '&'
            : '?'

        fetch(
          `${link}${separator}section_id=lt-main-qa`
        )
          .then(response => {
            if (!response.ok) {
              throw new Error(
                `Buy More CA: quick-shop request failed (${response.status})`
              )
            }

            return response.text()
          })
          .then(html => {
            const safeHTML =
              getSafeQuickShopHTML(
                html
              )

            T4SThemeSP.NTpopupInline(
              safeHTML,
              'lt-main-qa',
              initializeQuickShop,
              't4s-opening-qs'
            )

            body.trigger(
              'modalt4s:opened'
            )

            registerModalButton(
              this.flag
            )

            htmlData[cachedId] =
              safeHTML
          })
          .catch(error => {
            console.error(
              'Error opening Buy More CA quick shop:',
              error
            )
          })
          .finally(() => {
            button.classList.remove(
              addLoadingClass
            )
          })
      } catch (error) {
        console.error(
          'Error reading Buy More CA product data:',
          error
        )

        button.classList.remove(
          addLoadingClass
        )
      }
    }

    handleTextChange() {
      const count =
        this.selectedItems.length

      const oldPrice =
        this.selectedItems.reduce(
          (total, item) =>
            total +
            Number(item.price || 0),
          0
        )

      let price = oldPrice

      let priceHtml =
        this.selectedTemp
          .querySelector(
            '#select-0'
          )

      if (count >= 2) {
        price *=
          (100 - this.discount2) /
          100

        priceHtml =
          this.selectedTemp
            .querySelector(
              '#select-more'
            )
      } else if (count === 1) {
        price *=
          (100 - this.discount1) /
          100

        priceHtml =
          this.selectedTemp
            .querySelector(
              '#select-1'
            )
      }

      if (!priceHtml) return

      if (count > 0) {
        const countElement =
          priceHtml.querySelector(
            '.num'
          )

        const priceElement =
          priceHtml.querySelector(
            '.price'
          )

        const originalPrice =
          priceHtml.querySelector(
            '.price-origin'
          )

        if (countElement) {
          countElement.textContent =
            count
        }

        if (priceElement) {
          priceElement.textContent =
            T4SThemeSP.Currency
              ?.formatMoney(price) ||
            price
        }

        if (originalPrice) {
          originalPrice.textContent =
            T4SThemeSP.Currency
              ?.formatMoney(
                oldPrice
              ) || oldPrice

          originalPrice
            .classList.remove(
              'hidden'
            )
        }
      } else {
        const originalPrice =
          priceHtml.querySelector(
            '.price-origin'
          )

        if (originalPrice) {
          originalPrice
            .classList.add(
              'hidden'
            )
        }
      }

      if (this.selectedText) {
        this.selectedText.innerHTML =
          priceHtml.innerHTML
      }
    }

    handleDotChange() {
      const count =
        this.selectedItems.length

      this.steps.forEach(
        (step, index) => {
          step.classList.toggle(
            'active',
            index < count
          )
        }
      )

      if (count >= 2) {
        this.discountText
          .textContent =
          `Get ${this.discount2}% OFF`

        this.discountText
          .classList.add(
            'active'
          )
      } else if (count === 1) {
        this.discountText
          .textContent =
          `Get ${this.discount1}% OFF`

        this.discountText
          .classList.add(
            'active'
          )
      } else {
        this.discountText
          .textContent =
          `Get ${this.discount1}% OFF`

        this.discountText
          .classList.remove(
            'active'
          )
      }

      if (count > 0) {
        this.addToCartButton
          .removeAttribute(
            'disabled'
          )

        this.addToCartButton
          .removeAttribute(
            'aria-disabled'
          )
      } else {
        this.addToCartButton
          .setAttribute(
            'disabled',
            'disabled'
          )

        this.addToCartButton
          .setAttribute(
            'aria-disabled',
            'true'
          )
      }
    }

    handleRemoveItem(
      closeButton
    ) {
      const slide =
        closeButton.closest(
          '.swiper-slide'
        )

      if (!slide) return

      const id = slide.dataset.id

      const itemIndex =
        this.selectedItems
          .findIndex(
            item =>
              item.eid === id
          )

      if (itemIndex === -1) return

      this.selectedItems.splice(
        itemIndex,
        1
      )

      this.updateSection(
        [itemIndex],
        'remove'
      )
    }

    groupByQuantity(items) {
      return Object.entries(
        items.reduce(
          (result, id) => {
            result[id] =
              (result[id] || 0) +
              1

            return result
          },
          {}
        )
      ).map(
        ([id, quantity]) => ({
          id: Number(id),
          quantity,
        })
      )
    }

    handleAddToCart() {
      const items =
        this.groupByQuantity(
          this.selectedItems.map(
            item => String(item.id)
          )
        )

      const totalCount =
        this.selectedItems.length

      if (items.length === 0) {
        return
      }

      this.addToCartButton
        .classList.add(
          'is--loading'
        )

      const root =
        window.Shopify
          ?.routes?.root || '/'

      fetch(
        `${root}cart/add.js`,
        {
          method: 'POST',
          headers: {
            'Content-Type':
              'application/json',
            Accept:
              'application/json',
          },
          body: JSON.stringify({
            items,
          }),
        }
      )
        .then(response => {
          if (!response.ok) {
            return response
              .json()
              .catch(() => ({}))
              .then(errorData => {
                throw new Error(
                  errorData
                    .description ||
                    `Cart request failed (${response.status})`
                )
              })
          }

          return response.json()
        })
        .then(() => {
          this.selectedItems = []
          this.updateSection()

          if (totalCount === 1) {
            window.location.href =
              `${root}discount/MOMCA10?redirect=${root}cart`
          } else {
            window.location.href =
              `${root}cart`
          }
        })
        .catch(error => {
          console.error(
            'Error adding Buy More CA items to cart:',
            error
          )

          alert(
            'Sorry, there was an error adding items to the cart. Please try again.'
          )
        })
        .finally(() => {
          this.addToCartButton
            .classList.remove(
              'is--loading'
            )
        })
    }

    handleLoadMore(event) {
      event.preventDefault()
      event.stopPropagation()

      if (!this.loadMoreBtn) {
        return
      }

      if (
        this.loadMoreBtn
          .classList.contains(
            'is--loading'
          )
      ) {
        return
      }

      this.loadMoreBtn
        .classList.add(
          'is--loading'
        )

      const start = this.visibleProductCount
      const end = Math.min(
        start + this.productsPerPage,
        this.productBatchItems.length
      )

      this.productBatchItems
        .slice(start, end)
        .forEach(item => {
          item.style.display = 'contents'
        })

      this.visibleProductCount = end

      if (this.currentPageEl) {
        this.currentPageEl.textContent =
          `You've viewed ${this.visibleProductCount} of ${this.productBatchItems.length} products`
      }

      if (
        this.loadMoreBar &&
        this.productBatchItems.length > 0
      ) {
        this.loadMoreBar.style.width =
          `${(
            this.visibleProductCount /
            this.productBatchItems.length
          ) * 100}%`
      }

      this.loadMoreBtn.classList.remove(
        'is--loading'
      )

      if (
        this.visibleProductCount >=
        this.productBatchItems.length
      ) {
        this.loadMorePagination?.remove()
      }

      this.updateEvents()
    }
  }

  function initializeBuyMoreCA() {
    const sections =
      document.querySelectorAll(
        '.bmsm-section'
      )

    sections.forEach(section => {
      if (
        section.dataset
          .buyMoreCaInitialized ===
        'true'
      ) {
        return
      }

      section.dataset
        .buyMoreCaInitialized =
        'true'

      new BuyMoreCA(section)
    })
  }

  if (
    typeof ltLazyLoad ===
    'function'
  ) {
    ltLazyLoad(
      initializeBuyMoreCA
    )
  } else if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initializeBuyMoreCA,
      { once: true }
    )
  } else {
    initializeBuyMoreCA()
  }
})()